export const SITE_URL = 'https://www.caloriescience.ai';
export const BLOG_AUTHOR_NAME = 'Vandana Pramod';

export type BlogSeoMetadata = {
  slug: string;
  href: string;
  category: string;
  publishedDate: string;
  displayDate: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  primaryKeyword: string;
  secondaryKeywords: string[];
  imagePath: string;
  imageAlt?: string;
};

const publishedDate = '2026-06-04';
const displayDate = '4 JUN 2026';

export const blogSeoMetadata: BlogSeoMetadata[] = [
  {
    slug: 'client-management-platforms-for-nutritionists',
    href: '/blog/client-management-platforms-for-nutritionists',
    category: 'Practice Operations',
    publishedDate: '2026-07-25',
    displayDate: '25 JUL 2026',
    title:
      'Client Management Platforms for Nutritionists: How to Choose One for a Modern Practice (2026)',
    metaTitle: 'Client Management Platforms for Nutritionists (2026 Guide)',
    metaDescription:
      'Compare the best client management platforms for nutritionists and see why AI-powered, all-in-one software is becoming the platform of choice for modern nutrition practices.',
    primaryKeyword: 'client management platforms for nutritionists',
    secondaryKeywords: [
      'platform for modern nutrition practices',
      'nutrition practice management software',
      'dietitian client management software',
      'nutrition CRM',
      'all-in-one nutrition software',
      'AI-assisted nutrition platform',
    ],
    imagePath: '/images/landing/blog-2.svg',
    imageAlt:
      'Nutrition practitioner reviewing client records, meal plans and follow-ups in a modern practice platform.',
  },
  {
    slug: 'how-to-get-clients-as-a-nutritionist-uk',
    href: '/blog/how-to-get-clients-as-a-nutritionist-uk',
    category: 'Practice Growth',
    publishedDate,
    displayDate,
    title: 'How to Get More Clients as a Nutritionist in the UK — The 11-Part Growth System (2026)',
    metaTitle: 'How to Get More Clients as a Nutritionist in the UK: 11 Proven Strategies (2026)',
    metaDescription:
      'Want to know how to get clients as a nutritionist in the UK? These 11 proven strategies — from local SEO and AI nutrition software to referral networks — help you grow your nutrition practice in the UK and see more clients in less time.',
    primaryKeyword: 'how to get clients as a nutritionist UK',
    secondaryKeywords: [
      'grow nutrition practice UK',
      'client retention nutrition practice',
      'nutrition practice management software UK',
      'AI nutrition software UK',
      'nutrition software for professionals',
      'nutritionist business growth UK',
    ],
    imagePath: '/images/landing/blog-1.svg',
    imageAlt:
      'UK nutritionist reviewing client meal plans inside the CalorieScience practice platform — desktop view.',
  },
  {
    slug: 'best-clinical-nutrition-platforms-uk-healthcare-practitioners',
    href: '/blog/best-clinical-nutrition-platforms-uk-healthcare-practitioners',
    category: 'Clinical Nutrition Software',
    publishedDate,
    displayDate,
    title:
      'Best Clinical Nutrition Platforms for Healthcare Practitioners in the UK (2026): Top 7 Ranked by Features, Clinical Depth and Time Saved',
    metaTitle: 'Best Clinical Nutrition Platforms for Healthcare Practitioners UK (2026)',
    metaDescription:
      'Searching for the best clinical nutrition platform for practitioners? We rank the top 7 platforms for healthcare practitioners, dietitians, GPs, nutritionists, and more, by features, clinical depth and time saved.',
    primaryKeyword: 'best clinical nutrition platform UK',
    secondaryKeywords: [
      'clinical nutrition software',
      'nutritionist platform',
      'nutrition analysis software for dietitians',
      'AI-assisted platform for nutrition practitioners',
    ],
    imagePath: '/images/landing/blog-2.svg',
  },
  {
    slug: 'ai-assisted-nutrition-platform-professionals-uk',
    href: '/blog/ai-assisted-nutrition-platform-professionals-uk',
    category: 'AI and Automation',
    publishedDate,
    displayDate,
    title:
      'AI-Assisted Nutrition Platform for Professionals: How UK Nutritionists Are Using AI to Serve More Clients in Less Time (2026)',
    metaTitle:
      'AI-Assisted Nutrition Platform for Professionals: How UK Nutritionists Are Using AI to Serve More Clients in Less Time (2026)',
    metaDescription:
      'Discover how UK nutritionists and dietitians are using AI-assisted nutrition platforms to automate meal planning, reduce admin, and grow their client base, without adding working hours.',
    primaryKeyword: 'AI-assisted nutrition platform for professionals',
    secondaryKeywords: [
      'AI meal planning software for nutritionists',
      'nutrition practice management software UK',
      'personalised nutrition software UK',
      'automated meal planning for dietitians',
    ],
    imagePath: '/images/landing/blog-3.svg',
  },
];

export const blogSeoMetadataBySlug = blogSeoMetadata.reduce<Record<string, BlogSeoMetadata>>(
  (postsBySlug, post) => {
    postsBySlug[post.slug] = post;
    return postsBySlug;
  },
  {}
);

export const getAbsoluteSiteUrl = (path: string) => {
  if (path.startsWith('http')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
